export const iconFontAwesomeMoneyIndianRupeeSign = (
	<i className="fa-solid fa-indian-rupee-sign"></i>
);
